import React, {useMemo} from "react"
import {
	AppBar,
	Toolbar,
	Typography,
	Container,
	FormControl,
	Select,
	MenuItem,
	InputLabel,
	Grow,
	Grid,
} from "@mui/material"
import Alerts from "./Alerts/Alerts"
import Barcode from "./Barcode/Barcode"
import UpcomingClasses from "./UpcomingClasses/UpcomingClasses"
import Renewals from "./UpcomingPayments/UpcomingPayments"
import Account from "./Remaining/Remaining"
import { SelectChangeEvent } from "@mui/material/Select"
import { BeatLoader } from "react-spinners"
import { blue } from "../../theme"
import dayjs from 'dayjs'
import Notifications from "../../components/AlertMessage/Notifications"
import styles from "../../styles"
import {env} from "../../utils/enviroment"

const classes: any = {
	paper: {
		pt: 2,
		mt: { xs: 5, md: 6 },
		width: "100%",
		mb: { xs: "70px", md: "20px" },
	},
	appBar: {
		justifyContent: "center",
		top: 55,
		bottom: "auto",
		height: "55px",
		zIndex: 1,
	},
	toolbar: {
		justifyContent: "center",
	},
	position: {
		pl: { md: 10 },
		mb: { xs: 6, sm: 0 },
		ml: "auto",
		mr: "auto",
		display: "flex",
	},
	dropDown: {
		color: "white",
		".MuiOutlinedInput-notchedOutline": {
			borderColor: "rgba(228, 219, 233, 0.25)",
		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "rgba(228, 219, 233, 0.25)",
			color: "white",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "rgba(228, 219, 233, 0.25)",
		},
		".MuiSvgIcon-root ": {
			fill: "white !important",
		},
		".MuiFormLabel-root-MuiInputLabel-root.Mui-focused": {
			color: "white !important",
		},
	},
	inputLabel: {
		color: "secondary",
		"&.Mui-focused": { color: "white" },
	},
}

export default function Dashboard(props: any) {
	const { memberID, userConfig } = props
	const [user, setUser] = React.useState(userConfig?.clientId)
	const [endDate] = React.useState(dayjs().add(7, "days"))
	const config = {
		headers: {
			Authorization: `Bearer ${userConfig ? userConfig.token : null}`,
		},
		partnerApiKey: userConfig ? userConfig.partnerApiKey : null,
		businessAlias: userConfig ? userConfig.businessAlias : null,
		id: userConfig ? userConfig.clientId : null,
		startDate: new Date().toISOString().slice(0, 10),
		endDate: endDate.toISOString().slice(0, 10),
	}
	const config2 = {
		headers: {
			Authorization: `Bearer ${userConfig ? userConfig.token : null}`,
		},
		partnerApiKey: userConfig ? userConfig.partnerApiKey : null,
		businessAlias: userConfig ? userConfig.businessAlias : null,
		id: userConfig ? userConfig.clientId : null,
	}
	React.useEffect(() => {
		props.getRelatedUsers(config2)
		config.id = user
		props.getDashboardData(config)
		props.getDashboardAlerts(config)
		props.getProfileInfo(config)
	}, [user])

	const handleUserChange = (event: SelectChangeEvent) => {
		setUser(event.target.value as string)
	}

	const purchaseForUsers = useMemo(() => {
		const currentUser = { id: userConfig?.clientId, fullName: userConfig?.fullName };
		if (!props.purchaseForUsers) {
			return [currentUser]
		}	
		const ids = props.purchaseForUsers?.map((user: any) => user.id) || [];
		return ids.includes(userConfig?.clientId)
			? props.purchaseForUsers
			: [currentUser, ...props.purchaseForUsers];

	}, [user, props.purchaseForUsers]);

	return (
		<Grid direction="column" sx={classes.paper} container justifyContent="center">
			<AppBar sx={classes.appBar} position="fixed">
				<Toolbar sx={classes.toolbar}>
					<Grid container sx={{ justifyContent: "space-between", flexDirection: "row", width: "100%" }}>
						<Grid size={4}></Grid>
						<Grid size={4}>
							<Typography
								component="h3"
								variant="h5"
								align="center"
								sx={{ pl: { md: 7.5 }, color: "white", pt: "2px" }}
							>
								Dashboard
							</Typography>
						</Grid>
						<Grid size={4}>
							<Grid container justifyContent="flex-end">
								{purchaseForUsers?.length ? (
									<FormControl>
										<InputLabel sx={classes.inputLabel}>View As:</InputLabel>
										<Select
											size="small"
											sx={classes.dropDown}
											// disabled={props.requesting}
											label={"View As"}
											value={user}
											onChange={handleUserChange}
										>
											{purchaseForUsers.map((user: any) => (
												<MenuItem key={user.id} value={user.id}>
													{user.fullName}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								) : null}
							</Grid>
						</Grid>
					</Grid>
				</Toolbar>
			</AppBar>
			{props.loadError && (
				<Typography sx={[styles.modal, { mt: 10 }]} align="center">
					There was an error loading dashboard
				</Typography>
			)}
			{!props.errors ? (
				<Container maxWidth="lg" sx={classes.position}>
					{props.requestingAlerts ? (
						<Grid container sx={{justifyContent: "center", mt: 20, width: "100%"}}>
							<BeatLoader size={12} color={blue} />
						</Grid>
					) : (
						<Grid
							container
							spacing={2.5}
							sx={{justifyContent: "center", mt: 8 }}
						>
							{memberID && (
								<Grow in={true} timeout={{ enter: 1000 }}>
									<Grid size={{ xs: 12, lg: 10, md: 12 }}>
										<Barcode {...props} />
									</Grid>
								</Grow>
							)}

							<Grow in={true} timeout={{ enter: 1000 }}>
								<Grid size={{ xs: 12, lg: 10, md: 12 }}>
									<Alerts {...props} />
								</Grid>
							</Grow>
							<Grow in={true} timeout={{ enter: 1500 }}>
								<Grid size={{ lg: 10, xs: 12 }}>
									<UpcomingClasses {...props} />
								</Grid>
							</Grow>
							<Grow in={true} timeout={{ enter: 2000 }}>
								<Grid size={{ xs: 12, sm: 12, md: 6, lg: 5 }}>
									<Account {...props} />
								</Grid>
							</Grow>
							<Grow in={true} timeout={{ enter: 2000 }}>
								<Grid size={{ xs: 12, sm: 12, md: 6, lg: 5 }}>
									<Renewals {...props} />
								</Grid>
							</Grow>

							<Grid size={{ xs: 12}} display="flex" justifyContent="center">
								<Typography align="center" gutterBottom marginTop={6} color="textDisabled" variant="caption">
									Version: {env.get('VITE_VERSION', '0.0.0')}
								</Typography>
							</Grid>
						</Grid>
					)}
				</Container>
			) : (
				<Notifications
					messages={props.messages}
					errors={props.errors}
					hide={true}
				/>
			)}
		</Grid>
	)
}
